import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import utils from '@/jslibs/utils' // getToken from cookie


NProgress.configure({
	showSpinner: false
}) // NProgress Configuration

// 用户管理
import ListManage from './modules/user/list';

// 会员管理
import MemberManage from './modules/member/list';
import MemberTag from './modules/member/tag';

// 代理管理
import ProxyList from './modules/proxy/list';
import ProxyLevel from './modules/proxy/level';

// 推广管理
import PromotionList from './modules/promotion/list';

// 产品管理
import ProductList from './modules/product/list';
import ProductCategory from './modules/product/category';
import ProductFilter from './modules/product/filter';
import ProductCommentAudit from './modules/product/commentAudit';
import ProductComment from './modules/product/comment';
import ProductRecommend from './modules/product/recommend';
import ProductWatermark from './modules/product/watermark';
import ProductWord from './modules/product/word';

// 方案管理
import PlanList from './modules/plan/list';
import PlanCategory from './modules/plan/category';

// 优惠券管理
import CouponList from './modules/coupon/list';

// 案例管理
import CaseList from './modules/case/list';
import CaseCategory from './modules/case/category';

// 视频管理
import VideoList from './modules/video/list';
import VideoCategory from './modules/video/category';

// 文件管理
import FileList from './modules/file/list';
import FileCategory from './modules/file/category';

// 内容管理
import ContentAbout from './modules/content/about';
import ContentBanner from './modules/content/banner';
import ContentChannel from './modules/content/channel';
import ContentContact from './modules/content/contact';
import ContentFollow from './modules/content/follow';
import ContentFooter from './modules/content/footer';
import ContentHome from './modules/content/home';
import ContentHot from './modules/content/hot';
import ContentLink from './modules/content/link';
import ContentMine from './modules/content/mine';
import ContentStory from './modules/content/story';
import ContentSubscribe from './modules/content/subscribe';
import ContentPrivacy from './modules/content/privacy';
import ContentUse from './modules/content/use';
import ContentCookie from './modules/content/cookie';

// 权限管理
import RoleManage from './modules/auth/role';
import UserManage from './modules/auth/user';
import LogManage from './modules/auth/log';

// 数据管理
import Stat from './modules/data/stat';

// 消息通知
import MsgList from './modules/msg/list';

const Login = () => import('@/pages/Login');
const Index = () => import('@/pages/Index');
Vue.use(Router);

const whiteList = ['/login'] // no redirect whitelist

var children = [
	// 新
	...ListManage,
	...MemberManage,
	...MemberTag,
	...ProxyList,
	...ProxyLevel,
	...PromotionList,
	...ProductList,
	...ProductCategory,
	...ProductFilter,
    ...ProductCommentAudit,
	...ProductComment,
	...ProductRecommend,
	...ProductWatermark,
	...ProductWord,
	...PlanList,
	...PlanCategory,
	...CouponList,
	...CaseList,
	...CaseCategory,
	...VideoList,
	...VideoCategory,
	...FileList,
	...FileCategory,
	...ContentAbout,
	...ContentBanner,
	...ContentChannel,
	...ContentContact,
	...ContentFollow,
	...ContentFooter,
	...ContentHome,
	...ContentHot,
	...ContentLink,
	...ContentMine,
	...ContentStory,
	...ContentSubscribe,
	...ContentPrivacy,
	...ContentUse,
	...ContentCookie,

	...RoleManage,
	...UserManage,
	...LogManage,
	
	...Stat,
	...MsgList,
];

const router = new Router({
	routes: [{
		path: '',
		redirect: '/user/list'
	}, {
		path: '/login',
		component: Login
	}, {
		path: '/index',
		component: Index,
		children
	}]
	// mode: 'history',
});


router.beforeEach((to, from, next) => {
	children = [];
	NProgress.start()
	if (utils.getCookie("authorization")) {
		// 已登录且要跳转的页面是登录页
		if (to.path === '/login') {
			//console.log("login")
			next()
			NProgress.done()
		} else {
			next()
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
			NProgress.done()
		}
	}

})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})

export default router;
